/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Session_90_HintInputs */

const en_us2_profile_editors_session_90_hint = /** @type {(inputs: Profile_Editors_Session_90_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More volume per session`)
};

const pt_br2_profile_editors_session_90_hint = /** @type {(inputs: Profile_Editors_Session_90_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais volume por sessão`)
};

const es_419_profile_editors_session_90_hint = /** @type {(inputs: Profile_Editors_Session_90_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más volumen por sesión`)
};

const pt_pt2_profile_editors_session_90_hint = /** @type {(inputs: Profile_Editors_Session_90_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais volume por sessão`)
};

const fr_fr2_profile_editors_session_90_hint = /** @type {(inputs: Profile_Editors_Session_90_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de volume par séance`)
};

const de_de2_profile_editors_session_90_hint = /** @type {(inputs: Profile_Editors_Session_90_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr Volumen pro Einheit`)
};

const it_it2_profile_editors_session_90_hint = /** @type {(inputs: Profile_Editors_Session_90_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più volume per sessione`)
};

/**
* | output |
* | --- |
* | "More volume per session" |
*
* @param {Profile_Editors_Session_90_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_session_90_hint = /** @type {((inputs?: Profile_Editors_Session_90_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Session_90_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_session_90_hint(inputs)
	if (locale === "es-419") return es_419_profile_editors_session_90_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_session_90_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_session_90_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_session_90_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_session_90_hint(inputs)
	return en_us2_profile_editors_session_90_hint(inputs)
});
export { profile_editors_session_90_hint as "profile-editors.session_90_hint" }